module.exports = __webpack_public_path__ + "static/media/countdown-title-mobile.52b493c2.png";